
import { useCallback, useEffect, useMemo, useState } from "react"
import { useLocation, useParams  } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { customerRegister, getEventForm } from "../../api/event"
import { Form, message } from "antd";

export const useEventCustomer = props => {

    const { formatMessage } = useIntl();

    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const {pathname, search} = useLocation ()
    const {merchant_code} = useParams()
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [urlParams, setUrlParams] = useState(null);
    const [merchantCode, setMerchantCode] = useState('');

    const [allSelectOptions, setAllSelectOptions] = useState({});
    const [allSelectValues, setAllSelectValues] = useState({});
    const [allOriginOptions, setAllOriginOptions] = useState([]);
    const [formToken, setFormToken] = useState({});
    const [warrantyGroup, setWarrantyGroup] = useState([]);

    const [fileList, setFileList] = useState([]);
    const [base64List, setBase64List] = useState([]);

    const [dateString, setDateString] = useState('');

    const [btnDisable, setBtnDisable] = useState(false);

    const [searchValue, setSearchValue] = useState({});

    /**  upload相关 start** */
    const handleRemoveFile = useCallback((file)=>{
        const d_index = base64List.indexOf(data=>data.id === file.uid);
        if(d_index >= 0) {
            const newBase64List = base64List.slice();
            newBase64List.splice(d_index, 1);
            setBase64List(newBase64List);
        }
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        setFileList(newFileList);
    }, [fileList, base64List])

    const handleBeforeUpload = useCallback((file)=>{
        const isJpgOrPng = file.type === "image/png" || file.type === "image/gif" || file.type === "image/jpg" || file.type === "image/jpeg" || file.type === "application/pdf";
        if (!isJpgOrPng) {
            messageApi.open({
                type: 'error',
                content: formatMessage({
                    id: "form.uploadTypeTips", 
                    defaultMessage: "Allowed file types: png gif jpg jpeg pdf."
                }),
            });
            return false;
        }
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isLt2M) {
            messageApi.open({
                type: 'error',
                content: formatMessage({
                    id: "form.uploadSizeTips", 
                    defaultMessage: "Files must be less than 5MB."
                }),
            });
            return false;
        }
        return isJpgOrPng && isLt2M;
    }, [formatMessage, messageApi])

    const handleFormatFile = useCallback((option)=>{
        const formData = new FormData();
        formData.append("files[]", option.file);
        const reader = new FileReader();
        reader.readAsDataURL(option.file);
        reader.onloadend = function(e) {
            setBase64List([{
                id: option.file.uid,
                data: e.target.result // 保存图片的base64
            }])
            if (e && e.target && e.target.result) {
                option.onSuccess();
            }
        };
    }, [])

    const handleOnChangeFile = useCallback((info)=>{
        setFileList(info.fileList);
    }, [])
    /**  upload相关 end** */

    //改变form数据的格式
    const handleFormatWarrantyGroup = useCallback((data)=>{
        let allOrigins = [];
        let allSelects = {};
        let allValues = {};
        data.forEach(item=>{
            item?.fields?.forEach(f_item=>{
                if(f_item.options?.length && f_item.display) {
                    allOrigins.push({
                        name: f_item.field_code,
                        label: f_item.field_name,
                        options: f_item.options
                    });
                    allSelects[f_item.field_code] = [
                        ...f_item.options.filter(option=>!option.is_rely)
                    ];
                    allValues[f_item.field_code] = '';
                }
            })
        })
        setAllOriginOptions(allOrigins);
        setAllSelectOptions(allSelects);
        setAllSelectValues(allValues);
        setWarrantyGroup(data);
    }, [])

    //获取form数据
    const handleGetFormData = useCallback((uuid, isFirst, c_code, language, event_code)=>{
        //setLoading(true);
        getEventForm({
            code: event_code || 'default',
            language: language,
            event_uuid: uuid
        }, c_code).then(res=>{
            if(res?.code === 200) {
                if(res.data?.event_register_group?.length && res.data?.submit_url) {
                    setErrorMessage(null);
                    if(isFirst) {
                        handleFormatWarrantyGroup(res.data?.event_register_group);
                    }
                    setFormToken({
                        submit_url: `${c_code === '' ? '' : c_code.slice(0, -1)}${res.data?.submit_url}`,
                        event_name: res.data?.event_name
                    })
                }
                else {
                    setErrorMessage("Empty Form")
                }
            }
            else {
                setErrorMessage(res?.message)
            }
            setLoading(false);
            setBtnDisable(false);
        }).catch(error=>{
            setErrorMessage(error.response?.data?.message || error.message);
            setLoading(false);
            setBtnDisable(false);
        })
    }, [handleFormatWarrantyGroup]);

    //返回rules
    const handleGetRules = useCallback((is_required, validate, field_name)=>{
        let rules = [];
        if(is_required) {
            rules.push({
                required: true, message: formatMessage({
                    id: "form.is_required", 
                    defaultMessage: "{name} is required!"
                }, {
                    name: field_name
                })
            })
        }
        if(validate === 'email') {
            rules.push({
                pattern: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: formatMessage({
                    id: "form.isEmail", 
                    defaultMessage: "Please enter a valid email account"
                })
            })
        }
        else if(validate === 'mobile') {
            rules.push({
                pattern: /^\d+$/,
                message: formatMessage({
                    id: "form.isPhone", 
                    defaultMessage: "Please enter a valid mobile number"
                })
            })
        }
        return rules;
    }, [formatMessage])

    //select改变内容时，其他联动select也跟着变
    const handleChangeSelect = useCallback((field_code, val)=>{
        setSearchValue({});
        if(field_code === 'category') {
            const findField = allOriginOptions.find(item=>item.options.find(o_item=>o_item.is_rely && o_item.relyField === 'category' && o_item.relyValue === val));
            setAllSelectValues(selectValues=>{
                return  {
                    ...selectValues,
                    [field_code]: val,
                    series: '',
                    sku: '',
                }
            })
            form.setFieldValue(field_code, val);
            form.setFieldValue('series', '');
            form.setFieldValue('sku', '');
            const seriesOptions = findField?.options?.filter(option=>option.is_rely && option.relyField === 'category' && option.relyValue === val);

            setAllSelectOptions(selectOptions=>{
                return {
                    ...selectOptions,
                    series: seriesOptions?.length ? [
                        {
                            label: formatMessage({
                                id: "form.seriesPlaceholder", 
                                defaultMessage: "- Select product series -"
                            }),
                            value: ''
                        },
                        ...seriesOptions
                    ] : [],
                    sku: []
                }
            })
        }
        else if(field_code === 'series') {
            const findField = allOriginOptions.find(item=>item.options.find(o_item=>o_item.is_rely && o_item.relyField === 'series' && o_item.relyValue === val));
            setAllSelectValues(selectValues=>{
                return  {
                    ...selectValues,
                    [field_code]: val,
                    sku: '',
                }
            })
            form.setFieldValue(field_code, val);
            form.setFieldValue('sku', '');
            const skuOptions = findField?.options?.filter(option=>option.is_rely && option.relyField === 'series' && option.relyValue === val);
            setAllSelectOptions(selectOptions=>{
                return {
                    ...selectOptions,
                    sku: skuOptions?.length ? [
                        {
                            label: formatMessage({
                                id: "form.skuPlaceholder", 
                                defaultMessage: "- Model No.(SKU) -"
                            }),
                            value: ''
                        },
                        ...skuOptions
                    ] : [],
                }
            })
        }
        else {
            form.setFieldValue(field_code, val);
            setAllSelectValues(selectValues=>{
                return {
                    ...selectValues,
                    [field_code]: val
                }
            })
        }
    }, [allOriginOptions, formatMessage, form]);

    //获取date的数据
    const handleChangeDatePicker = useCallback((date, dateString)=>{
        setDateString(dateString)
    }, []);

    //提交表单
    const handleSubmitForm = useCallback((values)=>{
        let fileRequire = false;
        warrantyGroup.forEach(item2=>{
            item2.fields?.forEach(item3=>{
                if(item3.field_code === 'upload') {
                    fileRequire = item3.is_required
                }
            })
        })
        if(fileRequire && base64List?.length === 0) {
            messageApi.open({
                type: 'error',
                content: formatMessage({
                    id: "form.uploadNumTips", 
                    defaultMessage: "Must be upload a file."
                }),
            });
            return;
        }
        const sentValues = {
            event_check_uuid: urlParams?.uuid,
            language: urlParams?.language || 'global',
            customer_data: {
                warranty_code: urlParams?.eventCode || 'default',
                language: urlParams?.language || 'global',
                ...values,
            }
        }
        setLoading(true);

        customerRegister(formToken.submit_url, sentValues).then(res=>{
            if(res?.code === 200) {
                if(res?.data?.register_status == '200') {
                    messageApi.open({
                        type: 'info',
                        content: res?.data?.message || 'Register Success',
                    });
                    form.resetFields();
                    if(!btnDisable) {
                        setBtnDisable(true);
                        setTimeout(()=>{
                            handleGetFormData(urlParams?.uuid, false, merchantCode, urlParams?.language, urlParams?.eventCode);
                        }, 5000);
                    }
                }
                else {
                    messageApi.open({
                        type: 'error',
                        content: res?.data?.message || 'Register Failed',
                    });
                    if(!btnDisable) {
                        setBtnDisable(true);
                        handleGetFormData(urlParams?.uuid, false, merchantCode, urlParams?.language, urlParams?.eventCode);
                    }
                }
            }
            else {
                messageApi.open({
                    type: 'error',
                    content: res?.message,
                });
                if(!btnDisable) {
                    setBtnDisable(true);
                    handleGetFormData(urlParams?.uuid, false, merchantCode, urlParams?.language, urlParams?.eventCode);
                }
            }
            setLoading(false);
            setSearchValue({});
        }).catch(error=>{
            setLoading(false);
            if(!btnDisable) {
                setBtnDisable(true);
                handleGetFormData(urlParams?.uuid, false, merchantCode, urlParams?.language, urlParams?.eventCode);
            }
            messageApi.open({
                type: 'error',
                content: error.response?.data?.message || error.message,
            });
            setSearchValue({});
        })
    }, [warrantyGroup, base64List, urlParams, messageApi, formToken, formatMessage, handleGetFormData, btnDisable, merchantCode, form])

    useEffect(()=>{
        if(pathname.includes('/event') && search && merchant_code) {
          const params = new URLSearchParams(search);
          const uuid = params.get('uuid');
          const language = params.get('language') || 'global';
          const event_code = params.get('eventCode');
          const c_code = merchant_code === 'uat_test' ? '' : `api/merchant/${merchant_code}/event/`;
          setMerchantCode(c_code);
          if(uuid) {
            setUrlParams({
                uuid: uuid,
                language: language,
                eventCode: event_code
            })
            setLoading(true);
            handleGetFormData(uuid, true, c_code, language, event_code);
          }
          else {
            setErrorMessage("empty uuid")
          }
        }
        else {
            setErrorMessage("empty form")
        }
      }, [search, pathname])

    return {
        loading,
        errorMessage,
        form,
        warrantyGroup,
        allSelectOptions,
        allSelectValues,
        handleChangeSelect,
        contextHolder,
        fileList,
        handleRemoveFile,
        handleBeforeUpload,
        handleFormatFile,
        handleOnChangeFile,
        handleChangeDatePicker,
        handleSubmitForm,
        handleGetRules,
        formToken,
        searchValue,
        setSearchValue
    }
}